import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import addCustomizableProductToCartMutation from '~/graphql/cart/addCustomizableProductToCart.gql';
import addGiftCardToCartMutation from '~/graphql/cart/addGiftCardToCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import addSellerIdToCartMutation from '~/graphql/cart/addSellerIdToCart.gql';
import cartQuery from '~/graphql/cart/cart.gql';
import cartTotalQuantityQuery from '~/graphql/cart/cartTotalQuantity.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import mergeOrderFormToCartMutation from '~/graphql/cart/mergeOrderFormToCart.gql';
import minicartQuery from '~/graphql/cart/minicart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

// Some prettify waiting Apollo's refacto for links use.
// https://www.apollographql.com/docs/react/api/link/introduction/
function getHeaders(token) {
  return {
    Authorization: token ? "Bearer ".concat(token) : ''
  };
}
function fetchCartTotalQuantity(_x, _x2) {
  return _fetchCartTotalQuantity.apply(this, arguments);
}
function _fetchCartTotalQuantity() {
  _fetchCartTotalQuantity = _asyncToGenerator(function* (context, _ref) {
    var {
      reference,
      token
    } = _ref;
    var data = yield context.app.apolloProvider.defaultClient.query({
      query: cartTotalQuantityQuery,
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      context: {
        headers: getHeaders(token)
      },
      variables: {
        reference
      }
    });
    return data;
  });
  return _fetchCartTotalQuantity.apply(this, arguments);
}
function fetchCart(_x3, _x4) {
  return _fetchCart.apply(this, arguments);
}
function _fetchCart() {
  _fetchCart = _asyncToGenerator(function* (context, _ref2) {
    var {
      reference,
      token
    } = _ref2;
    yield context.app.apolloProvider.defaultClient.query({
      query: minicartQuery,
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      context: {
        headers: getHeaders(token)
      },
      variables: {
        reference
      }
    });
    return {
      data: {
        minicart: {
          items: [],
          quantity: 0
        }
      }
    };
  });
  return _fetchCart.apply(this, arguments);
}
function getOrderFormPaymentEligibility(_x5, _x6) {
  return _getOrderFormPaymentEligibility.apply(this, arguments);
}
function _getOrderFormPaymentEligibility() {
  _getOrderFormPaymentEligibility = _asyncToGenerator(function* (context, _ref3) {
    var {
      maskedQuoteId,
      token
    } = _ref3;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      query: cartQuery,
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      context: {
        headers: getHeaders(token)
      },
      variables: {
        reference: maskedQuoteId
      }
    });
    var isElegible = [];
    data.cart.groupedItems.forEach(el => {
      isElegible.push(el.items.reduce((acc, item) => {
        acc.push(item.product.buyable);
        return acc;
      }, []));
    });
    return isElegible.flat().every(value => value === true);
  });
  return _getOrderFormPaymentEligibility.apply(this, arguments);
}
function gethasVpProductInCart(_x7, _x8, _x9) {
  return _gethasVpProductInCart.apply(this, arguments);
}
function _gethasVpProductInCart() {
  _gethasVpProductInCart = _asyncToGenerator(function* (context, token, cartToken) {
    var _data$cart;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      query: cartQuery,
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      context: {
        headers: getHeaders(token)
      },
      variables: {
        isPrivateSales: true,
        reference: cartToken
      }
    });
    return data === null || data === void 0 ? void 0 : (_data$cart = data.cart) === null || _data$cart === void 0 ? void 0 : _data$cart.groupedItems.reduce((acc, groupedItem) => [...acc, ...(groupedItem === null || groupedItem === void 0 ? void 0 : groupedItem.items.map(el => {
      var _el$product, _el$product$price;
      return el === null || el === void 0 ? void 0 : (_el$product = el.product) === null || _el$product === void 0 ? void 0 : (_el$product$price = _el$product.price) === null || _el$product$price === void 0 ? void 0 : _el$product$price.isPrivateSales;
    }))], []).some(Boolean);
  });
  return _gethasVpProductInCart.apply(this, arguments);
}
function createCart(_x10, _x11) {
  return _createCart.apply(this, arguments);
}
function _createCart() {
  _createCart = _asyncToGenerator(function* (context, token) {
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: createNewCartMutation,
      context: {
        headers: getHeaders(token)
      }
    });
    return data;
  });
  return _createCart.apply(this, arguments);
}
function addCart(_x12, _x13) {
  return _addCart.apply(this, arguments);
}
function _addCart() {
  _addCart = _asyncToGenerator(function* (context, _ref4) {
    var {
      token,
      cart,
      reference,
      quantity,
      offer
    } = _ref4;
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: addProductsToCartMutation,
      context: {
        headers: getHeaders(token)
      },
      variables: {
        cart,
        products: [_objectSpread({
          reference,
          quantity
        }, offer && {
          offer
        })]
      }
    });
    return response;
  });
  return _addCart.apply(this, arguments);
}
function addCartCustomizable(_x14, _x15) {
  return _addCartCustomizable.apply(this, arguments);
}
function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator(function* (context, _ref5) {
    var {
      cart,
      token,
      payload
    } = _ref5;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: addCustomizableProductToCartMutation,
      context: {
        headers: getHeaders(token)
      },
      variables: {
        cart,
        reference: payload
      }
    });
    return data;
  });
  return _addCartCustomizable.apply(this, arguments);
}
function updateCart(_x16, _x17) {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = _asyncToGenerator(function* (context, _ref6) {
    var {
      token,
      cart,
      reference,
      quantity
    } = _ref6;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: updateCartMutation,
      context: {
        headers: getHeaders(token)
      },
      variables: {
        cart,
        items: [{
          reference,
          quantity
        }]
      }
    });
    return data;
  });
  return _updateCart.apply(this, arguments);
}
function addGiftCardToCart(_x18, _x19) {
  return _addGiftCardToCart.apply(this, arguments);
}
function _addGiftCardToCart() {
  _addGiftCardToCart = _asyncToGenerator(function* (context, _ref7) {
    var {
      cart,
      senderName,
      senderEmail,
      recipientName,
      recipientEmail,
      price,
      design,
      message,
      recaptchaToken,
      token
    } = _ref7;
    var response = yield context.defaultClient.mutate({
      mutation: addGiftCardToCartMutation,
      errorPolicy: 'all',
      context: {
        headers: getHeaders(token)
      },
      variables: {
        cart,
        senderName,
        senderEmail,
        recipientName,
        recipientEmail,
        price,
        design,
        message,
        recaptchaToken
      }
    });
    return response;
  });
  return _addGiftCardToCart.apply(this, arguments);
}
function addSellerIdToCart(_x20, _x21) {
  return _addSellerIdToCart.apply(this, arguments);
}
function _addSellerIdToCart() {
  _addSellerIdToCart = _asyncToGenerator(function* (context, _ref8) {
    var {
      cartToken,
      sellerId,
      token
    } = _ref8;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: addSellerIdToCartMutation,
      variables: {
        cartToken,
        sellerId
      },
      context: {
        headers: getHeaders(token)
      }
    });
    return data.addSellerIdToCart;
  });
  return _addSellerIdToCart.apply(this, arguments);
}
function mergeOrderFormToCart(_x22, _x23) {
  return _mergeOrderFormToCart.apply(this, arguments);
}
function _mergeOrderFormToCart() {
  _mergeOrderFormToCart = _asyncToGenerator(function* (defaultClient, orderFormId) {
    var {
      data
    } = yield defaultClient.mutate({
      mutation: mergeOrderFormToCartMutation,
      variables: {
        orderFormId
      }
    });
    return data.mergeOrderFormToCart;
  });
  return _mergeOrderFormToCart.apply(this, arguments);
}
export { addCart, addCartCustomizable, addGiftCardToCart, addSellerIdToCart, createCart, fetchCart, fetchCartTotalQuantity, getOrderFormPaymentEligibility, mergeOrderFormToCart, updateCart, gethasVpProductInCart };